import DeliveriesController from 'cio/controllers/deliveries';
import {
  LAST_12_MONTHS_RANGE_PRESET_LOCAL_FULL,
  LAST_12_WEEKS_FROM_NOW_RANGE_PRESET_LOCAL_FULL,
  LAST_30_DAYS_RANGE_PRESET_LOCAL_FULL,
  LAST_6_MONTHS_RANGE_PRESET_LOCAL_FULL,
  LAST_7_DAYS_RANGE_PRESET_LOCAL_FULL,
} from 'cio/utils/date-picker';

export default class IndexController extends DeliveriesController {
  filterQueryParams = ['action', 'recipient'];
  queryParams = ['actionType', 'action', 'recipient', 'deliveryStatus', 'startTs', 'endTs'];
  detailRoute = 'campaigns.campaign.overview.sent.delivery';
  icon = 'campaigns';

  dateRangePresets = [
    LAST_7_DAYS_RANGE_PRESET_LOCAL_FULL,
    LAST_30_DAYS_RANGE_PRESET_LOCAL_FULL,
    LAST_12_WEEKS_FROM_NOW_RANGE_PRESET_LOCAL_FULL,
    LAST_6_MONTHS_RANGE_PRESET_LOCAL_FULL,
    LAST_12_MONTHS_RANGE_PRESET_LOCAL_FULL,
  ];
}
